import type { FontRouter } from "replo-publisher/src/trpc/routers/font";

import { getNamespacedQueryClient } from "@v2/trpc/trpc";

import { createTrpcRouterConfig } from "../config";

const {
  router: fontRouter,
  client: fontClient,
  utils: fontUtils,
  options: fontOptions,
} = createTrpcRouterConfig<FontRouter>({
  path: "font",
  queryClient: getNamespacedQueryClient("font"),
});

export { fontClient, fontRouter, fontUtils, fontOptions };
